<template>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
   viewBox="0 0 253.4 275.3" style="enable-background:new 0 0 253.4 275.3;" xml:space="preserve">
    <g>
      <defs>
        <rect id="r2_1_" x="24.3" y="80.9" width="113.4" height="113.4"/>
      </defs>
      <clipPath id="r2_2_">
        <use xlink:href="#r2_1_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st0">
        <g>
          <defs>
            <path id="r2_3_" d="M24.3,185.3V89.9c0-2.4,0.9-4.7,2.6-6.4c1.7-1.7,4-2.6,6.4-2.6h95.4c2.4,0,4.7,0.9,6.4,2.6
              c1.7,1.7,2.6,4,2.6,6.4v95.4c0,2.4-0.9,4.7-2.6,6.4c-1.7,1.7-4,2.6-6.4,2.6H33.3c-2.4,0-4.7-0.9-6.4-2.6S24.3,187.7,24.3,185.3z
              "/>
          </defs>
          <clipPath id="r2_4_">
            <use xlink:href="#r2_3_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st1">
            <path class="st2" d="M24.3,194.3V80.9h113.4v113.4H24.3z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="r2_5_" x="125.7" y="80.9" width="113.4" height="113.4"/>
      </defs>
      <clipPath id="r2_6_">
        <use xlink:href="#r2_5_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st3">
        <g>
          <defs>
            <path id="r2_7_" d="M125.7,185.3V89.9c0-2.4,0.9-4.7,2.6-6.4c1.7-1.7,4-2.6,6.4-2.6h95.4c2.4,0,4.7,0.9,6.4,2.6
              c1.7,1.7,2.6,4,2.6,6.4v95.4c0,2.4-0.9,4.7-2.6,6.4s-4,2.6-6.4,2.6h-95.4c-2.4,0-4.7-0.9-6.4-2.6S125.7,187.7,125.7,185.3z"/>
          </defs>
          <clipPath id="r2_8_">
            <use xlink:href="#r2_7_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st4">
            <path class="st2" d="M125.7,194.3V80.9h113.4v113.4H125.7z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="r2_9_" x="74.3" y="80.9" width="113.4" height="113.4"/>
      </defs>
      <clipPath id="r2_10_">
        <use xlink:href="#r2_9_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st5">
        <g>
          <defs>
            <path id="r2_11_" d="M74.3,185.3V89.9c0-2.4,0.9-4.7,2.6-6.4c1.7-1.7,4-2.6,6.4-2.6h95.4c2.4,0,4.7,0.9,6.4,2.6
              c1.7,1.7,2.6,4,2.6,6.4v95.4c0,2.4-0.9,4.7-2.6,6.4c-1.7,1.7-4,2.6-6.4,2.6H83.3c-2.4,0-4.7-0.9-6.4-2.6S74.3,187.7,74.3,185.3z
              "/>
          </defs>
          <clipPath id="r2_12_">
            <use xlink:href="#r2_11_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st6">
            <path class="st2" d="M74.3,194.3V80.9h113.4v113.4H74.3z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="r2_13_" x="70" width="113.4" height="113.4"/>
      </defs>
      <clipPath id="r2_14_">
        <use xlink:href="#r2_13_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st7">
        <g>
          <defs>
            <path id="r2_15_" d="M79,0h95.4c2.4,0,4.7,0.9,6.4,2.6c1.7,1.7,2.6,4,2.6,6.4v95.4c0,2.4-1,4.7-2.6,6.4s-4,2.6-6.4,2.6H79
              c-2.4,0-4.7-0.9-6.4-2.6s-2.6-4-2.6-6.4V9c0-2.4,1-4.7,2.6-6.4C74.4,0.9,76.6,0,79,0z"/>
          </defs>
          <clipPath id="r2_16_">
            <use xlink:href="#r2_15_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st8">
            <path class="st2" d="M70,0h113.4v113.4H70V0z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="r2_17_" x="70" y="161.9" width="113.4" height="113.4"/>
      </defs>
      <clipPath id="r2_18_">
        <use xlink:href="#r2_17_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st9">
        <g>
          <defs>
            <path id="r2_19_" d="M79,161.9h95.4c2.4,0,4.7,0.9,6.4,2.6s2.6,4,2.6,6.4v95.4c0,2.4-1,4.7-2.6,6.4c-1.7,1.7-4,2.6-6.4,2.6
              H79c-2.4,0-4.7-0.9-6.4-2.6c-1.7-1.7-2.6-4-2.6-6.4v-95.4c0-2.4,1-4.7,2.6-6.4S76.6,161.9,79,161.9z"/>
          </defs>
          <clipPath id="r2_20_">
            <use xlink:href="#r2_19_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st10">
            <path class="st2" d="M70,161.9h113.4v113.4H70V161.9z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="r2_21_" y="10.9" width="253.4" height="253.4"/>
      </defs>
      <clipPath id="r2_22_">
        <use xlink:href="#r2_21_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st11">
        <g>
          <defs>
            <circle id="r2_23_" cx="126.7" cy="137.6" r="126.7"/>
          </defs>
          <clipPath id="r2_24_">
            <use xlink:href="#r2_23_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st12">
            <path class="st13" d="M0,10.9h253.4v253.4H0V10.9z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="r2_25_" x="51.8" y="62.7" width="149.8" height="149.8"/>
      </defs>
      <clipPath id="r2_26_">
        <use xlink:href="#r2_25_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st14">
        <g>
          <defs>
            <circle id="r2_27_" cx="126.7" cy="137.6" r="74.9"/>
          </defs>
          <clipPath id="r2_28_">
            <use xlink:href="#r2_27_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st15">
            <path class="st2" d="M51.8,62.7h149.8v149.8H51.8V62.7z"/>
          </g>
        </g>
      </g>
    </g>
    </svg>
</template>

<script>
export default {
  name: 'r2'
}
</script>

<style scoped>
  svg {
    width: 100%;
    height: 100%;
/*    fill: var(--principal);*/
/*    filter: brightness(0.9);*/
  }
</style>

<style scoped>
  .st0{clip-path:url(#r2_2_);}
  .st1{clip-path:url(#r2_4_);}
  .st2{fill:#2C6EDF;}
  .st3{clip-path:url(#r2_6_);}
  .st4{clip-path:url(#r2_8_);}
  .st5{clip-path:url(#r2_10_);}
  .st6{clip-path:url(#r2_12_);}
  .st7{clip-path:url(#r2_14_);}
  .st8{clip-path:url(#r2_16_);}
  .st9{clip-path:url(#r2_18_);}
  .st10{clip-path:url(#r2_20_);}
  .st11{clip-path:url(#r2_22_);}
  .st12{clip-path:url(#r2_24_);}
  .st13{fill:#75A0F1;}
  .st14{clip-path:url(#r2_26_);}
  .st15{clip-path:url(#r2_28_);}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/PosSettings/svg/r2.vue